module.exports = __webpack_public_path__ + "static/media/sass.eac0fdba.png";